<script setup lang="ts">
import { recordTypeHeading } from '@/components/commandPalette/groupQuickSearchResults';
import QuickSearchFieldTags from '@/components/search/QuickSearchFieldTags.vue';

/**
 * The tag rows a fields chip opens (SAU-467). A list shows one row. Cmd+K and the search
 * page stack one row for every record type the open tab searches, each under its name,
 * including a type with no hits, so a field can be turned on to find what the defaults
 * missed. The panel scrolls when it is taller than the room it has.
 */
defineProps<{
    entityIds: string[];
    id: string;
}>();
</script>

<template>
  <div :id="id" class="flex max-h-72 flex-col gap-3 overflow-y-auto" data-testid="quick-search-fields-panel">
    <QuickSearchFieldTags
      v-for="entityId in entityIds"
      :key="entityId"
      :entity-id="entityId"
      :heading="entityIds.length > 1 ? recordTypeHeading(entityId) : undefined"
    />
  </div>
</template>
